var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecked = function SvgChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "-1 -1 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10Z",
    fill: "#F9F5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 4,
    fill: "#FD7E60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19a9 9 0 0 1-9-9h-2c0 6.075 4.925 11 11 11v-2Zm9-9a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11h-2Zm-9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11v2Zm0-2C3.925-1-1 3.925-1 10h2a9 9 0 0 1 9-9v-2Z",
    fill: "#FD7E60"
  })));
};
export default SvgChecked;